import "../styles/Questionnaire.css";
import greenCheck from "../assets/green-check.png";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { checkSubmissionId } from "services/getApis";
import { useEffect } from "react";
import { ErrorToast } from "utils/toast";
import LoaderPulse from "components/Loader/LoaderPulse";
import constants from "config/constants";

const ValidatePayment = () => {
  const { submissionId } = useParams();
  const navigate = useNavigate();

  const { isLoading, isError } = useQuery({
    queryKey: ["scheduledEvent", submissionId],
    queryFn: () => checkSubmissionId(submissionId),
    enabled: !!submissionId,
    retry: 3,
  });

  useEffect(() => {
    if (isError) {
      ErrorToast(
        "Invalid submission ID. Please complete the questionnaire first.",
      );
      navigate("/questionnaire", { replace: true });
    }
  }, [isError, navigate]);

  const handleContinue = () => {
    window.location.href = constants.WebUrl;
  };

  return (
    <div className="questionnaire-container">
      <div className="questionnaire-content">
        {isLoading ? (
          <div
            style={{
              marginTop: "35%",
            }}
          >
            <LoaderPulse />
          </div>
        ) : (
          <>
            <div
              style={{
                marginTop: "5%",
              }}
            >
              <div className="success-screen">
                <div className="success-icon">
                  <img src={greenCheck} alt="Success" />
                </div>
                <h2 className="success-title">Payment Successful</h2>
                <p className="success-subtitle">
                  Your herbs are being reviewed by our specialist. Please
                  wait...
                </p>
                <button className="dashboard-btn" onClick={handleContinue}>
                  Go To Dashboard
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ValidatePayment;
